import {Trans, useTranslation} from "ni18n";
import React from "react";

import {ImgWithBg} from "../V5Comp";
import styles from "./How.module.scss";

const How = () => {
  const i18n = useTranslation();

  return (
    <div className={styles.wrap} id="how">
      <div className={styles.inner}>
        <div className={styles.rs}>
          <div className={styles.r}>
            <div className={styles.c1} />
            <div className={styles.c2}>
              <h1 className={styles.h1}>{i18n.t("How it works")}</h1>
            </div>
          </div>
          <div className={`${styles.r} mt4`}>
            <div className={styles.c1}>
              <span
                className={`${styles.icon} cIcon-guard`}
                style={{"--c": "#56336E", "--bg": "#F7E4F5"}}
              />
            </div>
            <div className={styles.c2}>
              <p>
                {i18n.t(
                  "To start, you'll create a Carbon account and complete a COVID-19 assessment. Carbon Health is a medical care provider, and the account you create will be used to secure your medical information and communicate with their clinical staff around your care.",
                )}
              </p>
            </div>
          </div>
          <div className={`${styles.r} mt12`}>
            <div className={styles.c1} />
            <div className={styles.c2}>
              <h5 className={styles.h2}>{i18n.t("ASSESSMENT")}</h5>
            </div>
          </div>

          <div className={`${styles.r} mt4`}>
            <div className={styles.c1}>
              <span
                className={`cIcon-icon-phone ${styles.icon}`}
                style={{"--c": "#1C4F75", "--bg": "#9EEAEF"}}
              />
            </div>
            <div className={styles.c2}>
              <p>
                {i18n.t(
                  "The COVID-19 assessment is a series of questions based on guidance from CDC, WHO and other public health authorities, as well as Carbon Health's experience testing and evaluating thousands of patients during the COVID-19 pandemic. This assessment creates a baseline of all enrolled staff, including:",
                )}
              </p>

              <ul className={`${styles.list} basic`}>
                {[
                  i18n.t("Whether you've been exposed"),
                  i18n.t("How likely you are to be exposed based on your daily activities"),
                  i18n.t("Risk of serious illness if you're infected"),
                  i18n.t(
                    "Who else (such as family) you might put at serious risk if you're infected.",
                  ),
                ].map(r => (
                  <li className={styles.li} key={r}>
                    {r}
                  </li>
                ))}
              </ul>

              <p className="mt8">
                {i18n.t(
                  "Based on your assessment, Carbon Health will recommend a course of action. Carbon Health's recommendations might include you getting tested because of your risk or symptoms, seeing a telehealth clinician, or doing nothing.",
                )}
              </p>
            </div>
          </div>

          <div className={`${styles.r} mt12`}>
            <div className={styles.c1} />
            <div className={styles.c2}>
              <h5 className={styles.h2}>{i18n.t("testing")}</h5>
            </div>
          </div>

          <div className={`${styles.r} mt4`}>
            <div className={styles.c1}>
              <span
                className={`${styles.icon} cIcon-flu-screening`}
                style={{"--c": "#88690C", "--bg": "#F3D95A"}}
              />
            </div>
            <div className={styles.c2}>
              <p>
                {i18n.t(
                  "Employees who need to be tested, based on their answers to the assessment, will be able to book a testing appointment with their Carbon Health account. Carbon Health will list ample testing options within the app.",
                )}
              </p>
            </div>
          </div>

          <div className={`${styles.r} mt12`}>
            <div className={styles.c1} />
            <div className={styles.c2}>
              <h5 className={styles.h2}>{i18n.t("daily checklist")}</h5>
            </div>
          </div>

          <div className={`${styles.r} mt4`}>
            <div className={styles.c1}>
              <span
                className={`${styles.icon} cIcon-pie-line-graph-desktop`}
                style={{"--c": "#C14111", "--bg": "#FCD1A1"}}
              />
            </div>
            <div className={styles.c2}>
              <p>
                {i18n.t(
                  "If your company participates in the Daily Symptom Tracker, you will receive a daily notification every day to check your symptoms.",
                )}
              </p>
            </div>
          </div>

          <div className={styles.box} id="about">
            <h5 className={styles.boxH} style={{color: "#24A06D"}}>
              {i18n.t("employee privacy")}
            </h5>
            <p className={styles.boxBody}>
              <Trans>
                Your symptoms and health history will <span className={styles.bold}>NOT</span> be
                shared with your employer. Your test results will be shared with your employer.
              </Trans>
            </p>
          </div>

          <div className={styles.s}>
            <div className={styles.s1}>
              <div className={styles.s11}>
                <h5 className={styles.s111}>{i18n.t("About Carbon health")}</h5>
                <div className={styles.s112}>
                  <div className={styles.s1121}>
                    <img
                      src="/static/img/_common/coloredLogo.svg"
                      alt="Carbon Health"
                      className={styles.s11211}
                    />
                  </div>
                  <div className={styles.s1122}>
                    <Trans>
                      <span className={styles.bold}>Carbon Health</span> is a technology enabled
                      healthcare provider that combines smart technology with inviting clinics and a
                      robust virtual offering. Carbon specializes in primary care, mental health,
                      and has been working tirelessly to make COVID-19 testing available to all.
                    </Trans>
                  </div>
                </div>
              </div>
            </div>
            <ImgWithBg className={styles.s2} bgImage="/covidReadyForOrgs/b1" />
            <ImgWithBg className={styles.s2} bgImage="/covidReadyForOrgs/b2" />
            <ImgWithBg className={styles.s2} bgImage="/covidReadyForOrgs/b3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default How;
